import React, { useState } from 'react';
import Marquee from 'react-fast-marquee';
import Deadline from './Deadline';
import Deadlinetext from './DeadlineData';
import DeadlinetextFr from './DeadlineDataFr';
import './Dealine_ScrollBar.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { makeStyles } from '@material-ui/core/styles';
var dlscrollfun;

const useStyles = makeStyles({
  toast: {
    top: '15%',
    ['@media (max-width:768px)']: {
      top: '13%',
      height: '90%',
    },
  },
});
function Dealine_ScrollBar(props) {
  const classes = useStyles();
  const [dlscroll, setdlscroll] = useState(true);
  dlscrollfun = (bool) => {
    setdlscroll(bool);
  };
  let DeadlineTextData;
  if (props.selectedLang === 'fr') {
    DeadlineTextData = DeadlinetextFr;
  } else {
    DeadlineTextData = Deadlinetext;
  }
  return (
    <>
      <div
        onClick={(event) => {
          event.stopPropagation();
        }}
        id="deadline"
        className="fixed-top"
      >
        <div className="deadlineContainer">
          <Marquee
            play={dlscroll}
            pauseOnClick={false}
            pauseOnHover={false}
            gradient={false}
            speed={'30'}
          >
            <div className="deadlineInner">
              <div className="deadlineItem" id="deadlineItem">
                {DeadlineTextData.map((deadline, i) => {
                  return <Deadline deadline={deadline} key={i} />;
                })}
              </div>
            </div>
          </Marquee>
        </div>
      </div>
      <ToastContainer className={classes.toast} />
    </>
  );
}

export { dlscrollfun };
export default Dealine_ScrollBar;
